const a = "_card_99a63_1", _ = "_icon_99a63_64", r = "_arrow_99a63_65", e = "_sm_99a63_98", s = "_lg_99a63_104", d = "_addIcon_99a63_124", o = "_addDashes_99a63_139", l = {
  card: a,
  icon: _,
  arrow: r,
  "has-icon": "_has-icon_99a63_71",
  "has-arrow-side": "_has-arrow-side_99a63_74",
  "has-arrow-external-side": "_has-arrow-external-side_99a63_75",
  "has-arrow-under": "_has-arrow-under_99a63_83",
  "has-arrow-external-under": "_has-arrow-external-under_99a63_84",
  sm: e,
  lg: s,
  "blue-blue": "_blue-blue_99a63_108",
  "blue-yellow": "_blue-yellow_99a63_109",
  "white-yellow": "_white-yellow_99a63_114",
  "white-blue": "_white-blue_99a63_119",
  addIcon: d,
  addDashes: o,
  "add-primary": "_add-primary_99a63_156",
  "add-critical": "_add-critical_99a63_157"
};
export {
  o as addDashes,
  d as addIcon,
  r as arrow,
  a as card,
  l as default,
  _ as icon,
  s as lg,
  e as sm
};
//# sourceMappingURL=card.module.less.js.map
